// Ex: [ 'fine-art', 'fine-art', 'conceptual', 'impressionism', 'modern', 'conceptual']
// Results ['fine-art', 'conceptual', 'impressionism', 'modern',]
export const restrictDuplicateValues = (facetValue) => {
  if (Array.isArray(facetValue)) {
    return facetValue.reduce(
      // if Item Exist, Return Results, else Append Item to Results
      (results, item) => (results.includes(item) ? results : [...results, item]),
      []
    )
  }

  // Single Object/String - Do Nothing
  return facetValue
}
